import { UserDto } from '@generated/auth-api';

export function isLoggedInForOrg(user: UserDto, requiredRight?: UserDto.RightsEnum) {
  return !!user && !!user.activeOrg && (!requiredRight || user.rights?.includes(requiredRight));
}
